import {
  inject, observer,
} from 'mobx-react';
import React, {
  Component,
} from 'react';
import NavigationTabs from '../../components/Tabs';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  IStatisticsStore,
} from '../../mobx-store/storeInterfaces/statisticsInterface';
import NotRegisteredUsers from './notRegisteredUsers';
import Users from './usersTable';
import SuspendedUsers from './suspendedusers';
import { AuthStore } from '../../mobx-store/stores/authStore';
import DetailedStatisticsScreen from './detailed-statistics';
import LimitedUsers from './limitedUsers';

interface IProps {
  history: any;
  statisticsStore: IStatisticsStore;
  authStore: AuthStore;
}

interface IState {
  value: number;
}

@inject('statisticsStore')
@inject('authStore')
@observer
class Statistics extends Component<IProps, IState> {
  isAdmin = false;
  tabsLabels: string[] = [];

  constructor(props: IProps) {
    super(props);
    this.state = {
      value: 0,
    };
  }

  componentWillMount() {
    const {
      authStore,
    } = this.props;
    const {
      userData,
    } = authStore;
    const {
      title,
    } = userData.role;
    this.isAdmin = title === 'Admin';
    this.tabsLabels = [
      translate('DetailedStatisticsTabTitle', {}),
      translate('UsersTableTabTitle', {}),
      translate('NotRegisteredUsersTabTitle', {}),
      // translate('limitedUsersTab'),
    ];
    if (this.isAdmin) {
      this.tabsLabels.push(translate('SuspendUsers', {}));
    }
  }

  render() {
    return (
      <div>
        <NavigationTabs
          tabLabels={this.tabsLabels}
          selected={0}
        >
          <DetailedStatisticsScreen />
          <Users />
          <NotRegisteredUsers />
          {/* <LimitedUsers {...this.props} /> */}
          <SuspendedUsers  {...this.props} />
        </NavigationTabs>
      </div>
    );
  }
}

export default Statistics;
